/**
 * OpenCallsSignup
 *
 * Form-creator (ajax with jquery): https://app.ungapped.com/Web/SubscriptionForms
 */
const OpenCallsSignup = {
  formEl: null,
  emailEl: null,
  doubleOptIdEl: null,
  policyEl: null,
  responseDiv: null,
  successText: "",
  errorTerms: "",
  errorGeneric: "",
  errorEmailEmpty: "",
  errorEmailWrong: "",
  errorSubscriber: "",

  init: () => {
    // get elements
    OpenCallsSignup.formEl = document.getElementById(
      "block-open-calls-signup__form"
    );
    OpenCallsSignup.emailEl = document.getElementById("contactEmail");
    OpenCallsSignup.doubleOptIdEl = document.getElementById("double-opt-id");
    OpenCallsSignup.policyEl = document.getElementById("contactConsentText");
    OpenCallsSignup.responseDiv = document.getElementById(
      "block-open-calls-signup-response"
    );

    // get validation strings
    if (OpenCallsSignup.responseDiv) {
      OpenCallsSignup.successText =
        OpenCallsSignup.responseDiv.dataset.successText;
      OpenCallsSignup.errorTerms =
        OpenCallsSignup.responseDiv.dataset.errorTerms;
      OpenCallsSignup.errorGeneric =
        OpenCallsSignup.responseDiv.dataset.errorGeneric;
      OpenCallsSignup.errorEmailEmpty =
        OpenCallsSignup.responseDiv.dataset.errorEmailEmpty;
      OpenCallsSignup.errorEmailWrong =
        OpenCallsSignup.responseDiv.dataset.errorEmailWrong;
      OpenCallsSignup.errorSubscriber =
        OpenCallsSignup.responseDiv.dataset.errorSubscriber;

      // console.log("1: ", OpenCallsSignup.successText);
      // console.log("2: ", OpenCallsSignup.errorTerms);
      // console.log("3: ", OpenCallsSignup.errorGeneric);
      // console.log("4: ", OpenCallsSignup.errorEmailEmpty);
      // console.log("5: ", OpenCallsSignup.errorEmailWrong);
      // console.log("6: ", OpenCallsSignup.errorSubscriber);
    }

    // submit
    if (OpenCallsSignup.formEl) {
      OpenCallsSignup.formEl.addEventListener("submit", (e) => {
        e.preventDefault();

        // get values
        let email = OpenCallsSignup.emailEl.value;
        let doubleOptId = OpenCallsSignup.doubleOptIdEl.value;
        let policy = OpenCallsSignup.policyEl.checked;

        if (!policy) {
          if (OpenCallsSignup.responseDiv)
            OpenCallsSignup.responseDiv.innerHTML = OpenCallsSignup.errorTerms;
        } else {
          OpenCallsSignup.ajaxRequest(email, doubleOptId);
        }
      });
    }
  },

  ajaxRequest: (email, doubleOptId) => {
    const $ = jQuery;

    $.ajax({
      type: "post",
      dataType: "json",
      url: "https://ui.ungpd.com/Api/Subscriptions/dd32c31b-4cd6-41e3-8ec3-d70d98d0b2e9/ajax",
      data: {
        ListIds: ["0da7bbde-8a38-4a5f-bfa0-370d2ad71299"],
        Contact: {
          Email: email,
        },
        ConsentText:
          "Jag vill få relevant information om utlysningar från Net Zero Industry till min inkorg. Net Zero Industry ska inte dela eller sälja mina personuppgifter. Jag kan avsluta prenumerationen när som helst.",
        DoubleOptIn: {
          Issue: { IssueId: doubleOptId },
        },
      },
      statusCode: {
        200: function (res) {
          console.log("success");
          OpenCallsSignup.responseDiv.innerHTML = OpenCallsSignup.successText;
        },
        400: function (xhr, status, error) {
          console.log("400");
          const message = xhr.responseJSON.Message;
          console.log(message);
          console.log(xhr.responseJSON);

          let response = OpenCallsSignup.errorGeneric;

          if (message == "No contact information provided") {
            response = OpenCallsSignup.errorEmailEmpty;
          } else if (message == "Invalid email") {
            response = OpenCallsSignup.errorEmailWrong;
          } else if (message == "Subscription already exists") {
            response = OpenCallsSignup.errorSubscriber;
          } else {
            response = message;
          }

          OpenCallsSignup.responseDiv.innerHTML = response;
        },
      },
    });

    return false;
  },
};

export default OpenCallsSignup;
